import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NAME as ACCOUNT_NAME } from '@app/account/constants';
import { NAME as MARKETING_NAME } from '@app/marketing/constants';
import { useRouter } from 'next/router';
import { i18n } from 'next-i18next';

// Data
import { getAssetsUrls } from '@core/contentful/helper';
import { fetchMarketingData } from '@core/contentful/fetchMarketingData';

// UI
import SignupForm from '@app/account/components/SignupForm';
import MainLayout from '@ui/layouts/Main.layout';
import MetaTags from '@ui/components/MetaTags';

// Types
import { NextPage } from 'next';
import { ContentfulPageProps } from '@core/types';

interface Props extends ContentfulPageProps {
    metaTitle: string;
    metaDescription: string;
}

export const SignupPage: NextPage<Props> = ({
    testimonials,
    logoUrls,
    title,
    description,
    metaTitle,
    metaDescription,
}) => {
    const { locale, pathname } = useRouter();

    return (
        <>
            <MetaTags
                title={metaTitle}
                description={metaDescription}
                locale={locale}
                pathname={pathname}
            />

            <MainLayout
                title={title}
                description={description}
                logoUrls={logoUrls}
                testimonials={testimonials}
                activeStep="register"
            >
                <div className="mt-12">
                    <SignupForm />
                </div>
            </MainLayout>
        </>
    );
};

export default SignupPage;

export const getStaticProps = async ({ locale }) => {
    const response = await fetchMarketingData(locale);
    const t = i18n?.getFixedT(locale, ACCOUNT_NAME);

    return {
        props: {
            ...(await serverSideTranslations(locale, [MARKETING_NAME, ACCOUNT_NAME, 'common'])),
            // Will be passed to the page component as props
            title: response.fields.signupTitle,
            description: response.fields.signupDescription,
            metaTitle: t?.('page-title-signup') || '',
            metaDescription: t?.('page-description-signup') || '',
            logoUrls: getAssetsUrls(response.fields.logos),
            testimonials: response.fields.testimonialSlider,
        },
    };
};
